/**
 * search-autocomplete.js
 * Predictive search using Shopify's /search/suggest.json API.
 *
 * Usage: add data-search-input to an <input> and data-search-suggestions
 * to its sibling dropdown container.
 */
(function () {
  'use strict';

  var SUGGEST_URL = '/search/suggest.json';
  var DEBOUNCE_MS = 250;
  var MIN_CHARS = 2;

  function init() {
    document.querySelectorAll('[data-search-input]').forEach(function (input) {
      var dropdown = document.querySelector('[data-search-suggestions="' + input.dataset.searchInput + '"]');
      if (dropdown) attach(input, dropdown);
    });
  }

  function attach(input, dropdown) {
    var debounceTimer;
    var popularHtml = dropdown.innerHTML;
    var labelProducts = dropdown.dataset.labelProducts || 'Products found';
    var labelViewAll = dropdown.dataset.labelViewAll || 'View all results for';
    var userInteracted = false;

    // Segna interazione utente reale (non autofocus)
    input.addEventListener('mousedown', function () { userInteracted = true; });
    input.addEventListener('touchstart', function () { userInteracted = true; }, { passive: true });
    input.addEventListener('keydown', function () { userInteracted = true; });

    function open() {
      dropdown.classList.add('is-open');
    }

    function close() {
      dropdown.classList.remove('is-open');
    }

    function reset() {
      dropdown.innerHTML = popularHtml;
    }

    input.addEventListener('focus', function () {
      if (!userInteracted) return; // ignora autofocus da page load
      if (input.value.trim().length < MIN_CHARS) reset();
      open();
    });

    input.addEventListener('input', function () {
      var query = input.value.trim();
      clearTimeout(debounceTimer);

      if (query.length < MIN_CHARS) {
        reset();
        open();
        return;
      }

      debounceTimer = setTimeout(function () {
        fetchSuggestions(query, dropdown, labelProducts, labelViewAll);
      }, DEBOUNCE_MS);
    });

    input.addEventListener('keydown', function (e) {
      var items = dropdown.querySelectorAll('[data-suggestion-item]');
      var current = dropdown.querySelector('[data-suggestion-item].is-active');
      var idx = Array.prototype.indexOf.call(items, current);

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        var next = idx < items.length - 1 ? idx + 1 : 0;
        setActive(items, next);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        var prev = idx > 0 ? idx - 1 : items.length - 1;
        setActive(items, prev);
      } else if (e.key === 'Enter' && current) {
        e.preventDefault();
        window.location.href = current.href;
      } else if (e.key === 'Escape') {
        close();
        input.blur();
      }
    });

    document.addEventListener('click', function (e) {
      if (!input.contains(e.target) && !dropdown.contains(e.target)) {
        close();
      }
    });
  }

  function setActive(items, index) {
    items.forEach(function (item, i) {
      item.classList.toggle('is-active', i === index);
    });
  }

  function fetchSuggestions(query, dropdown, labelProducts, labelViewAll) {
    var url = SUGGEST_URL + '?q=' + encodeURIComponent(query)
      + '&resources[type]=product'
      + '&resources[limit]=6'
      + '&resources[options][unavailable_products]=last'
      + '&resources[options][fields]=title,variants.title,vendor';

    fetch(url)
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        if (!data) return;
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        renderProducts(products, query, dropdown, labelProducts, labelViewAll);
        dropdown.classList.add('is-open');
      })
      .catch(function () { /* silently fail */ });
  }

  function renderProducts(products, query, dropdown, labelProducts, labelViewAll) {
    if (products.length === 0) {
      dropdown.innerHTML = '<div class="search-suggestions__empty">' + labelViewAll + ' <strong>' + escHtml(query) + '</strong></div>';
      return;
    }

    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    var locale = document.documentElement.lang || 'it-IT';
    var formatter = new Intl.NumberFormat(locale, { style: 'currency', currency: currency });

    var html = '<div class="search-suggestions__header">' + escHtml(labelProducts) + '</div>';

    products.forEach(function (product) {
      var price = product.price_min != null
        ? formatter.format(parseFloat(product.price_min))
        : '';
      var imgSrc = product.featured_image && product.featured_image.url
        ? product.featured_image.url.replace(/(\.[a-z]+)$/, '_60x60_crop_center$1')
        : '';
      var imgHtml = imgSrc
        ? '<img src="' + escAttr(imgSrc) + '" alt="" class="search-suggestion__img" width="40" height="40" loading="lazy">'
        : '<span class="search-suggestion__img search-suggestion__img--placeholder"></span>';

      html += '<a href="' + escAttr(product.url) + '" class="search-suggestion search-suggestion--product" data-suggestion-item>'
        + imgHtml
        + '<span class="search-suggestion__body">'
        + '<span class="search-suggestion__title">' + highlight(product.title, query) + '</span>'
        + (price ? '<span class="search-suggestion__price">' + escHtml(price) + '</span>' : '')
        + '</span>'
        + '</a>';
    });

    html += '<a href="/search?q=' + encodeURIComponent(query) + '&type=product" class="search-suggestion search-suggestion--all" data-suggestion-item>'
      + escHtml(labelViewAll) + ' <strong>' + escHtml(query) + '</strong>'
      + '</a>';

    dropdown.innerHTML = html;
  }

  function highlight(text, query) {
    var safe = escHtml(text);
    var escaped = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return safe.replace(new RegExp('(' + escaped + ')', 'gi'), '<mark>$1</mark>');
  }

  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escAttr(str) {
    return String(str).replace(/"/g, '&quot;');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
